import { Route } from 'react-router-dom';
import { PAYROLL_PREP_VIEW_KEYS } from '@attendance/shared';
import { ManageRoute } from '../components/auth/ManageRoute.js';
import { PayPeriodsPage, PayrollPrepPage } from '../lazyPages.js';

/* ===========================================================================
 * PAYROLL — preparation (`/payroll`) and the pay-period lock
 * (`/payroll/periods`, audit H-06). One fragment for the reason
 * `approvalDoorRoutes.tsx` gives (App.tsx is size debt behind a ratchet);
 * spliced in as `{PAYROLL_ROUTES}`, and listed in `test/appRouteSource.ts` so the
 * route-gate suites read it.
 *
 * Each route carries the same gate as its nav row in `navGroups.ts`;
 * `routeGates.test.tsx` fails when the two disagree.
 * ======================================================================== */
export const PAYROLL_ROUTES = (
  <>
    <Route
      path="payroll"
      element={
        <ManageRoute permission={PAYROLL_PREP_VIEW_KEYS} feature="payroll">
          <PayrollPrepPage />
        </ManageRoute>
      }
    />
    <Route
      path="payroll/periods"
      element={
        <ManageRoute permission="pay.periods.view" feature="payroll">
          <PayPeriodsPage />
        </ManageRoute>
      }
    />
  </>
);
